import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onBeforeUnmount } from "vue";
import { useToast } from "primevue/usetoast";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const toast = useToast();

store.state.win.w = window.innerWidth;
store.state.win.h = window.innerHeight;

store.watch(
  (state) => state.msgToast,
  (msgToast) => {
    if (msgToast.det !== "") {
      toast.add({
        severity: msgToast.sev,
        summary: msgToast.sum,
        detail: msgToast.det,
        life: 4000,
      });
    }
  }
);

// get query params on page load
onMounted(() => {
  // Nastav event listener pri zmene velkosti obrazovky
  window.addEventListener("resize", () => {
    store.state.win.w = window.innerWidth;
    store.state.win.h = window.innerHeight;
  });
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", () => {
    store.state.win.w = window.innerWidth;
    store.state.win.h = window.innerHeight;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_Toast)
  ], 64))
}
}

})